/* unplugin-vue-components disabled */import { render } from "./user_edit.vue?vue&type=template&id=0d712582&scoped=true"
import script from "./user_edit.vue?vue&type=script&lang=js"
export * from "./user_edit.vue?vue&type=script&lang=js"

import "./user_edit.vue?vue&type=style&index=0&id=0d712582&scoped=true&lang=css"

import exportComponent from "D:\\un-app\\zsmy_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d712582"]])

export default __exports__